export let LightboxMixins = {
    data: {
        lightboxMedia: []
    },
    methods: {
        showLightbox: function(id, idx) {
            let vm = this;
            let lightbox = vm.$refs['lightbox-'+id];
            if (lightbox) {
                vm.lightboxMedia.splice(0, vm.lightboxMedia.length);
                let gallery = vm.$refs['gallery-'+id];
                let slides = gallery.querySelectorAll(".slide-for-"+id);
                slides.forEach(function(it) {
                    let img = it.firstChild;
                    let m = {
                        thumb: img.getAttribute("src"),
                        src: img.getAttribute("src"),
                        caption: it.getAttribute("data-caption")
                    }
                    vm.lightboxMedia.push(m);
                });
                lightbox.showImage(idx);
            }
        }
    }
}